import * as ActionTypes from './../Actions/EnumTypes/ActionEnumTypes';
import * as AOIActionModel from './../Actions/Models/AOIActionModel';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import * as AOIModule from 'Modules/AOIModule';
import * as UserModel from 'Models/UserModel';
import { reset } from 'redux-form';

function getAoiList(userId?: number, showSideLoader?: boolean) {
    return async dispatch => {
        try {
            if(showSideLoader) {
                dispatch(ViewManagementModule.Actions.showDetailsSidebarLoader());
            }
            const aoiList = await AOIModule.Connector.getAOIList(userId ? userId : null);
            dispatch(getAoiSuccess(aoiList.data.areaOfInterestList));

            if(showSideLoader) {
                dispatch(ViewManagementModule.Actions.hideDetailsSidebarLoader());
            }
        } catch (err) {
            dispatch(ViewManagementModule.Actions.hideDetailsSidebarLoader());
        }
    };
}

function addAoi(aoiDetails: AOIModule.Types.AddAreaOfInterestRequest) {
    return async dispatch => {
        try {
            dispatch(ViewManagementModule.Actions.showLoader());
            await AOIModule.Connector.addAOI(aoiDetails);
            dispatch(addAoiSuccess());
            dispatch(reset('addAoiForm'));
            await dispatch(getAoiList());
            dispatch(ViewManagementModule.Actions.hideAddingAOIandWipeCoords());
            dispatch(ViewManagementModule.Actions.hideLoader());
        } catch (err) {
            dispatch(ViewManagementModule.Actions.hideLoader());
            dispatch(addAoiFailure(err ? err.response.data : null));
        }
    };
}

function updateAoi(aoiDetails: AOIModule.Types.AddAreaOfInterestRequest, aoiId: number) {
    return async dispatch => {
        try {
            dispatch(ViewManagementModule.Actions.showLoader());
            await AOIModule.Connector.updateAoi(aoiDetails, aoiId);
            dispatch(updateAoiSuccess());
            dispatch(reset('addAoiForm'));
            dispatch(hideAoiDetailsPopup());
            await dispatch(getAoiList());
            dispatch(setDetailsForAoiView(null));
            dispatch(ViewManagementModule.Actions.hideLoader());
            dispatch(ViewManagementModule.Actions.hideAddingAOIandWipeCoords());
        } catch (err) {
            dispatch(ViewManagementModule.Actions.hideLoader());
            dispatch(addAoiFailure(err ? err.response.data : null));
        }
    };
}

function deleteAoi(aoiID: number) {
    return async dispatch => {
        try {
            dispatch(ViewManagementModule.Actions.showLoader());
            await AOIModule.Connector.deleteAOI(aoiID);
            dispatch(deleteAoiSuccess());
            await dispatch(getAoiList());
            dispatch(ViewManagementModule.Actions.hideLoader());
        } catch (err) {
            dispatch(ViewManagementModule.Actions.hideLoader());
            dispatch(deleteAoiFailure(err.response.data));
        }
    };
}

function getAoiSuccess(aoiList: Array<AOIModule.Types.AreaOfInterestDto>): AOIActionModel.GetAOISuccessAction {
    return {
        type: ActionTypes.AOI.GET_AOI_LIST_SUCCESS,
        payload: {
            aoiList
        }
    };
}

function getAoiFailure(error: UserModel.Types.Error): AOIActionModel.GetAOIFailureAction {
    return {
        type: ActionTypes.AOI.GET_AOI_LIST_FAILURE,
        payload: {
            error
        }
    };
}

function addAoiSuccess(): AOIActionModel.AddAOISuccessAction {
    return {
        type: ActionTypes.AOI.ADD_AOI_SUCCESS
    };
}

function updateAoiSuccess(): AOIActionModel.UpdateAOISuccessAction {
    return {
        type: ActionTypes.AOI.UPDATE_AOI_SUCCESS
    };
}
function addAoiFailure(error: UserModel.Types.Error): AOIActionModel.ADDAOIFailureAction {
    return {
        type: ActionTypes.AOI.ADD_AOI_FAILURE,
        payload: {
            error
        }
    };
}

function deleteAoiSuccess(): AOIActionModel.DeleteAOISuccessAction {
    return {
        type: ActionTypes.AOI.DELETE_AOI_SUCCESS
    };
}

function deleteAoiFailure(error: UserModel.Types.Error): AOIActionModel.DeleteAOIFailureAction {
    return {
        type: ActionTypes.AOI.DELETE_AOI_FAILURE,
        payload: {
            error
        }
    };
}
function setDetailsForAoiView(activeAoi: AOIModule.Types.AreaOfInterestDto): AOIActionModel.SetDetailsForAoiView {
    return {
        type: ActionTypes.AOI.SET_DETAILS_FOR_AOI_VIEW,
        payload: {
            activeAoi
        }
    };
}
function showAoiDetailsPopup(): AOIActionModel.ShowAoiPopupManagement {
    return {
        type: ActionTypes.AOI.AOI_DETAILS_POPUP_SHOW
    };
}
function hideAoiDetailsPopup(): AOIActionModel.HideAoiPopupManagement {
    return {
        type: ActionTypes.AOI.AOI_DETAILS_POPUP_HIDE
    };
}
function addCoordsToNewZone(newZoneCoord: L.LatLngExpression): AOIActionModel.AddNewCoordsToZone {
    return {
        type: ActionTypes.AOI.ADD_COORDS_TO_NEW_ZONE,
        payload: {
            newZoneCoord
        }
    };
}
function clearCoordsOfNewZone(): AOIActionModel.ClearCoordsOfNewZone {
    return {
        type: ActionTypes.AOI.CLEAR_COORDS_OF_NEW_ZONE
    };
}
export { getAoiList, addAoi, deleteAoi, setDetailsForAoiView, showAoiDetailsPopup, hideAoiDetailsPopup, addCoordsToNewZone, clearCoordsOfNewZone, updateAoi };



// WEBPACK FOOTER //
// ./src/Redux/Actions/AOIActions.ts